import {useMutation, UseMutationResult} from '@tanstack/react-query';
import queryString from 'query-string';
import {useLocale} from 'state/locale';
import {toCamelCase} from 'utils/object';
import {request} from 'utils/request-axios';

export type CustomTemplateItem = {
    baseTemplateCode: string;
    displayName: string;
    documentType: string;
    draft: boolean;
    filename: string;
    mid: string;
    partner: {
        mid: string;
        name: string;
        url: string;
    };
    templateFileUrl: string;
    uploadedFileUrl: string;
    url: string;
};

export type CustomTemplateSearchApiResult = {
    pagination: {
        currentPage: number;
        endCount: number;
        numPages: number;
        startCount: number;
        totalCount: number;
    };
    request: SearchRequest;
    results: CustomTemplateItem[];
};

export type SearchRequest = {
    keyword: string;
    page?: number;
};

export const useGetCustomTemplateSearchResult = (): UseMutationResult<
    CustomTemplateSearchApiResult,
    Error,
    {mid: string} & SearchRequest
> => {
    const locale = useLocale();

    return useMutation(({mid, ...rest}) =>
        request({
            locale,
            method: 'GET',
            url: `/api/partner/${mid}/custom-template/search/?${queryString.stringify(
                rest,
            )}`,
        }).then((response) => toCamelCase(response)),
    );
};
